import { InvoiceRecord } from "@/app/Invoices/GraphQL/invoiceRecordQuery";
import { Badge } from "@/components/catalyst/badge";
import { contactTypeColorMap } from "@/app/Contacts/Utils/contactTypeColorMap";
import { useTranslations } from "use-intl";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { LinkButton } from "@/components/catalyst/button";
import {
  BriefcaseBusiness,
  MailIcon,
  MapPinIcon,
  PhoneIcon,
} from "lucide-react";
import { ArrowLeftEndOnRectangleIcon } from "@heroicons/react/20/solid";
export function InvoicePayeeCard({ invoice }: { invoice: InvoiceRecord }) {
  const t = useTranslations("contact");
  const tInvoice = useTranslations("invoice.detail");

  return (
    <Card className="overflow-hidden">
      <CardHeader className="relative flex flex-row items-start justify-between space-y-0">
        <div className="space-y-1">
          <p className="text-sm font-medium text-gray-500">
            {tInvoice("payee")}
          </p>
          <div className="-ml-3 flex items-center gap-2">
            <LinkButton
              plain
              to="."
              search={{
                contactId: invoice.payee.id,
              }}
            >
              {invoice.payee.legal_name ?? invoice.payee.name}{" "}
              <ArrowLeftEndOnRectangleIcon className="size-3.5" />
            </LinkButton>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Badge color={contactTypeColorMap[invoice.payee.type]}>
            {t(`type.${invoice.payee.type}`)}
          </Badge>
        </div>
      </CardHeader>

      <CardContent className="text-sm">
        <div className="grid gap-3">
          <dl className="grid gap-3">
            <div className="flex items-start gap-3">
              <BriefcaseBusiness
                className="mt-0.5 h-5 w-5 flex-shrink-0 text-gray-400"
                aria-hidden="true"
              />
              <div className="flex-1">
                <dt className="text-xs text-gray-500">
                  {tInvoice("businessNumber")}
                </dt>
                <dd className="mt-1 font-medium text-gray-900">
                  {invoice.payee.company_number ?? "--"}
                </dd>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <MailIcon
                className="mt-0.5 h-5 w-5 flex-shrink-0 text-gray-400"
                aria-hidden="true"
              />
              <div className="flex-1">
                <dt className="text-xs text-gray-500">{tInvoice("email")}</dt>
                <dd className="mt-1 font-medium text-gray-900">
                  {invoice.payee.billing_email ?? "--"}
                </dd>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <PhoneIcon
                className="mt-0.5 h-5 w-5 flex-shrink-0 text-gray-400"
                aria-hidden="true"
              />
              <div className="flex-1">
                <dt className="text-xs text-gray-500">{tInvoice("phone")}</dt>
                <dd className="mt-1 font-medium text-gray-900">
                  {invoice.payee.billing_phone ?? "--"}
                </dd>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <MapPinIcon
                className="mt-0.5 h-5 w-5 flex-shrink-0 text-gray-400"
                aria-hidden="true"
              />
              <div className="flex-1">
                <dt className="text-xs text-gray-500">
                  {tInvoice("billingAddress")}
                </dt>
                <dd className="mt-1 font-medium text-gray-900">
                  {invoice.payee.billingAddress?.formatted_address_line_1 ??
                    "--"}
                </dd>
              </div>
            </div>
          </dl>
        </div>
      </CardContent>
    </Card>
  );
}
